import { render, staticRenderFns } from "./main_out.vue?vue&type=template&id=51d97b36&scoped=true&"
import script from "./main_out.vue?vue&type=script&lang=js&"
export * from "./main_out.vue?vue&type=script&lang=js&"
import style0 from "./main_out.vue?vue&type=style&index=0&id=51d97b36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d97b36",
  null
  
)

export default component.exports